/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flavor_CreatedInputs */

const en_flavor_created = /** @type {(inputs: Flavor_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flavor created`)
};

const es_flavor_created = /** @type {(inputs: Flavor_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabor creado`)
};

/**
* | output |
* | --- |
* | "Flavor created" |
*
* @param {Flavor_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const flavor_created = /** @type {((inputs?: Flavor_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flavor_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flavor_created(inputs)
	return es_flavor_created(inputs)
});